import React from "react";

function DerivEHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Crypto Derivatives Exchange Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Build crypto derivatives exchange for seamless futures,
                    options, and perpetual swaps trading – tailored for the
                    modern crypto derivatives market.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DerivEHero;
